<div class="navbar-top">

  <div class="logo">
    <img class="logo-icon" [src]="_cdkConfigService.icone">
    <!-- ALTERADO PELA PGE-RS: comentado!
    <span class="logo-text text-secondary">{{_cdkConfigService.sigla}}</span>
    -->
  </div>

  <div class="buttons">

    <button mat-icon-button class="toggle-sidebar-folded lt-lg:hidden"
      (click)="toggleSidebarFolded()">
      <mat-icon class="text-secondary">menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened lg:hidden"
      (click)="toggleSidebarOpened()">
      <mat-icon class="text-secondary">arrow_back</mat-icon>
    </button>

  </div>

</div>


<div class="navbar-scroll-container"
  cdkScrollbar [cdkScrollbarOptions]="{wheelPropagation: false ,suppressScrollX: false}">

  <!-- ALTERADO PELA PGE-RS: comentado.
  <div class="user flex flex-col">

    <div class="h3 username">{{userProfile?.nome.split(' ')[0]}}</div>
    <div class="h5 email hint-text mt-2">{{userProfile?.email}}</div>
    <div class="avatar-container">
      @if (!!userProfile?.imgPerfil?.conteudo === false) {
        <img class="avatar" src="assets/images/avatars/User.png"
          >
      }
      @if (!!userProfile?.imgPerfil?.conteudo === true) {
        <img class="avatar" [src]="userProfile.imgPerfil.conteudo|safeResourceUrl"
          >
      }
    </div>
    

  </div>
  -->

  <div class="pge_navbar-content"><!-- ALTERADO PELA PGE-RS: para reduzir o espaço. -->
    <cdk-navigation class="material2" layout="vertical"></cdk-navigation>
  </div>

</div>
